module.exports = __webpack_public_path__ + "img/eleven.1ed8a798.png";